// extracted by mini-css-extract-plugin
export default {"icon":"Hf7vVOvWltHU0jkQ4gb5"};